import { render, staticRenderFns } from "./BusinessHeroLanding.vue?vue&type=template&id=82bcff8a&scoped=true&"
import script from "./BusinessHeroLanding.vue?vue&type=script&lang=ts&"
export * from "./BusinessHeroLanding.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessHeroLanding.vue?vue&type=style&index=0&id=82bcff8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bcff8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VLayout,VSheet})
